var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from "moment";
import { buildNutritionRequestBody, getDefaultCustomizeOptions, getRecipeNutrition, } from "../../../../../Shared/components/CustomizeModal/CustomizeModal-utils";
import { clone } from "../../../../../Shared/utils/clone";
import { ActionTypes } from "../../../../OrderFlowProvider/OrderFlowActionTypes";
import { getMustReplaceIngredients } from "../../../../hooks/RecipeSelection/recipeSelectionUtils";
import { handleCustomizeSubmit_V2 } from "./handleCustomizeSubmit_V2";
import { incrementRecipe_V2 } from "./incrementRecipe_V2";
/**
 * Increment the quantity of a recipe assignment for a meal. Immediately dispatches and updates the store.
 *
 * @param enableAssignRecipes
 * @param enableAddMeals
 * @param enableRemoveMeals
 * @param cartMeals
 * @param program
 * @param deliveryDays
 * @param sku
 * @param companyUsesKlaviyo
 * @param dispatch
 * @param createKlaviyoEvent
 * @param logReactPixel
 * @param selectedDay
 * @param reactPixelKey
 * @returns
 */
export const handleRecipeIncrement_V2 = ({ enableAssignRecipes, enableAddMeals, enableRemoveMeals, cartMeals, recipes, program, deliveryDays, sku, companyUsesKlaviyo, dispatch, createKlaviyoEvent, logReactPixel, selectedDay, datadogLog, reactPixelKey, recipe, programMealId, setMeals, setAssignmentId, createNewAssignment, shouldSetAssignmentId, }) => __awaiter(void 0, void 0, void 0, function* () {
    const clonedMeals = clone(cartMeals);
    const { meals, currentRecipeAssignment, mealPrice, mealName, mealDate } = yield incrementRecipe_V2({
        enableAssignRecipes,
        enableAddMeals,
        enableRemoveMeals,
        clonedMeals,
        program,
        deliveryDays,
        selectedDay,
        recipe,
        programMealId,
        assignmentId: undefined,
        createNewAssignment,
        shouldSetAssignmentId,
        setAssignmentId,
    });
    const { ingredientsToReplace } = getMustReplaceIngredients(recipe);
    if (ingredientsToReplace && ingredientsToReplace.length > 0) {
        const { options } = getDefaultCustomizeOptions(ingredientsToReplace, recipe, currentRecipeAssignment);
        const nutrition = yield getRecipeNutrition(recipe.RecipeId, buildNutritionRequestBody(options, recipe), datadogLog);
        // Default customizations need to be applied when the recipe quantity is incremented
        yield handleCustomizeSubmit_V2({
            recipes,
            selectedDay,
            dispatch,
            recipeId: recipe.RecipeId,
            programMealId,
            setMeals,
            selectedCustomizeOptions: options,
            meals,
            days: undefined,
            assignment: currentRecipeAssignment,
            nutrition,
        });
    }
    else {
        setMeals(meals);
        dispatch({ type: ActionTypes.SET_MEALS, payload: meals });
    }
    if (companyUsesKlaviyo) {
        let totalQuantity = 0;
        const mealsForKlaviyo = meals.filter((meal) => moment(meal.MealDate).isSame(moment(mealDate)) && meal.ProgramMealId === programMealId && meal.RecipeAssignments);
        mealsForKlaviyo.forEach((meal) => {
            var _a, _b, _c;
            totalQuantity +=
                (_c = (_b = (_a = meal === null || meal === void 0 ? void 0 : meal.RecipeAssignments) === null || _a === void 0 ? void 0 : _a.filter((ra) => ra.RecipeId === (recipe === null || recipe === void 0 ? void 0 : recipe.RecipeId))) === null || _b === void 0 ? void 0 : _b.reduce((accum, ra) => accum + ra.Quantity, 0)) !== null && _c !== void 0 ? _c : 0;
        });
        const eventInfo = {
            RecipeName: recipe.RecipeName,
            Quantity: totalQuantity,
            MealName: mealName,
            SKU: sku,
            DayOfWeek: moment(recipe.AvailableOn).format("ddd"),
        };
        createKlaviyoEvent("Added Recipe", eventInfo);
    }
    if (reactPixelKey) {
        const data = {
            content_name: recipe.RecipeName,
            content_ids: recipe.RecipeId,
            content_type: "meal",
            value: mealPrice,
            currency: "USD",
        };
        logReactPixel("AddMeal", data);
    }
});
